module.exports = __webpack_public_path__ + "static/flags/TT-7d5a3fd549ea1412eda9656c4cb5b05f.gif";